module.exports = __webpack_public_path__ + "img/103.10.3341a5e0.png";